export default __webpack_public_path__ + "static/media/trkrLogo.f7522940.png";